import { useState } from "react"
import { useTranslation } from "react-i18next"
import WarningMessage from "components/commons/WarningMessage"
import PageLayout from "components/layout/PageLayout"
import { useGetMyWorkerContractQuery } from "../workContract/api/workContractApiSlice"
import MyLeaveHoursLeft from "../workContract/components/MyLeaveHoursLeft"
import MyWorkerLeaveReport from "../workContract/components/MyWorkerLeaveReport"
import { useCancelRequestMutation, useGetMyAbsenceRequestsQuery } from "./api/absenceReportApiSlice"
import AbsenceRequestsTable, { KEY_ABSENCEREQUEST_ACTION_CANCEL_MY } from "./components/AbsenceRequestsTable"
import MyAbsenceCalendar from "./components/MyAbsenceCalendar"
import NewAbsenceRequestModal from "./components/NewAbsenceRequestModal"
import { selectCurrentUserGuid, selectCompanyGuid } from "features/auth/authSlice"
import { useSelector } from "react-redux"
import TopicSubscriber from "app/ws/TopicSubriber"


function MyAbsence() {

    const [sendingSuccess, setSendingSuccess] = useState(false)
    const [t, i18n] = useTranslation(["global", "absenceReport"])
    const userGuid = useSelector(selectCurrentUserGuid)
    const companyGuid = useSelector(selectCompanyGuid)

    const [requestPage, setRequestPage] = useState(0)
    const [cancelRequest, cancelingResult] = useCancelRequestMutation()

    const {
        data: response,
        isFetching,
        isSuccess,
        isError,
        error,
        refetch
    } = useGetMyAbsenceRequestsQuery(requestPage)

    const {
        data: workerContract,
        isSuccess: myWorkerContractIsSuccess,
        isError: myWorkerContractIsError,
    } = useGetMyWorkerContractQuery()

    function handleSendingSuccess() {
        setSendingSuccess(requestPage)
    }

    const handleCancel = (id) => {
        console.log(`The absence request (${id}) will be CANCELED`);
        cancelRequest(id)
    }

    const changePage = (page) => {
        console.log("Requesting page" + page + "...")
        setRequestPage(page)
    }

    Date.prototype.addDays = function (days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
    }

    function getDates(startDate, stopDate) {
        var dateArray = new Array();
        var currentDate = startDate;
        while (currentDate <= stopDate) {
            dateArray.push(new Date(currentDate));
            currentDate = currentDate.addDays(1);
        }
        return dateArray;
    }

    const dateTemplate = (date) => {
        if (date.day > 10 && date.day < 15) {
            return (
                <strong style={{ textDecoration: 'line-through' }}>{date.day}</strong>
            );
        }

        return date.day;
    }

    return (
        <PageLayout
            pageTitle={t("absenceReport:menu.my_absences")}
            onPageRefresh={refetch}
            isLoadingContent={isFetching}
            bodyContent={
                <>

                    {
                        myWorkerContractIsSuccess &&
                        <div className="">
                            <div className="">
                                <NewAbsenceRequestModal
                                    onSuccess={handleSendingSuccess}
                                />
                            </div>

                            <div className="">
                                <MyLeaveHoursLeft forceRefresh={isFetching} />
                            </div>
                            <MyAbsenceCalendar forceRefresh={isFetching}/>
                            <div className="card bg-black bg-opacity-10 mb-4">
                                <div className="card-body">
                                    <MyWorkerLeaveReport forceRefresh={isFetching} />
                                </div>
                            </div>
                        </div>
                    }

                    {
                        myWorkerContractIsError &&
                        <WarningMessage message="Non è possibile inviare richieste di assenza senza un contratto assegnato." />
                    }


                    <div>
                        {/* {isSuccess &&
                            <Calendar 
                            value={getDates(new Date(response.content[0].startDate*1000), new Date(response.content[0].endDate*1000))} 
                            onChange={(e) => { }} 
                            selectionMode="multiple" 
                            inline 
                            showOtherMonths={false}
                            dateTemplate={dateTemplate}
                             />
                        } */}
                    </div>

                    <div className="row mt-4">
                        <div className="col">

                            {isSuccess &&

                                <AbsenceRequestsTable
                                    title={t("absenceReport:menu.requests_sent")}
                                    items={response.content}
                                    onRequestCanceled={handleCancel}
                                    availableActions={[
                                        KEY_ABSENCEREQUEST_ACTION_CANCEL_MY
                                    ]}
                                    onPageChange={(number) => changePage(number - 1)}
                                    itemsPerPage={response.pageable.pageSize}
                                    totalItems={response.totalElements}
                                    currentPage={requestPage + 1}
                                />
                            }
                        </div>
                    </div>
                    <TopicSubscriber
                        subTopic={`company/${companyGuid}/user/${userGuid}`}
                        onMessageReceived={refetch}
                    />
                </>
            }
        />
    )
}

export default MyAbsence